import type { VariantProps } from "tailwind-variants";

import { tv } from "../utils/tv";

/**
 * Link wrapper **Tailwind Variants** component
 *
 * @example
 * <a className={link({ color: "secondary", isBlock: true })} href="#" />
 */
const logo = tv({
  base: ["w-auto h-auto text-foreground"],
  variants: {
    variant: {
      full: "",
      mini: "",
      favicon: "",
    },
  },
  defaultVariants: {
    variant: "full",
  },
});

export type LogoVariantProps = VariantProps<typeof logo>;

export { logo };
